import { useTranslation } from 'react-i18next';
import { ReactComponent as BookIcon } from '../../icons/book.svg';
import { ReactComponent as LinkIcon } from '../../icons/link.svg';
import { ReactComponent as DownloadIcon } from '../../icons/download.svg';
import './SellerManualUploadInstructionBlock.scss';
import { downloadFile } from '../../core/helpers';
import classNames from 'classnames';
import Button from '../Button';

export default function SellerManualUploadInstructionBlock() {
  const { t, i18n } = useTranslation();

  return (
    <div className='Paper ms-auto pt-4 pb-2 px-2 d-flex flex-column align-items-center justify-content-center mb-3'>
      <BookIcon />
      <div
        className='text-center my-3 Text--20 fw-800'
        dangerouslySetInnerHTML={{
          __html: t('How to prepare your Manual Turnover Data'),
        }}
      />
      <div
        className={classNames(
          'SellerManualUploadInstructionBlock__container d-flex flex-column',
          {
            'SellerManualUploadInstructionBlock__container--de':
              i18n.language === 'de',
          }
        )}
      >
        <a
          className='Button--outline py-1 px-2 d-inline-flex align-items-center mb-2'
          href={
            i18n.language === 'de'
              ? '/Manual_data_preparation_DE.pdf'
              : '/Manual_data_preparation_ENG.pdf'
          }
          target='_blank'
          rel='noopener noreferrer'
        >
          <LinkIcon className='SellerManualUploadInstructionBlock__icon me-2' />
          {t('Open instruction')}
        </a>
        <Button
          styling='outline'
          className='py-1 px-2 d-inline-flex align-items-center mb-3'
          onClick={() => {
            downloadFile(
              '/countX-Turnover-Import-Vorlage_Example.xlsx',
              'countX-Turnover-Import-Vorlage_Example.xlsx'
            );
          }}
        >
          <DownloadIcon className='SellerManualUploadInstructionBlock__download me-2' />
          {t('Download template')}
        </Button>
      </div>
    </div>
  );
}
